import { ServiceStatus } from './consts';

export function getServiceStatus(config, service) {
    let status = ServiceStatus.UNKNOWN;
    if (config && service && service.extra) {
        if (service.extra.integration_status) {
            status |= ServiceStatus.ENABLED;
        } else {
            status |= ServiceStatus.DISABLED;
        }
        if (config.methods.isInstalled(service)) {
            status |= ServiceStatus.ACTIVE;
        } else {
            status |= ServiceStatus.INACTIVE;
        }
    }
    return status;
}
